import { render } from "./UiElementverzweigungReadOnly.pug?vue&type=template&id=f929849a&lang=pug"
import script from "./UiElementverzweigungReadOnly.js?vue&type=script&lang=js"
export * from "./UiElementverzweigungReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__